import React, { useState, useEffect, useRef, useContext, useMemo } from "react";
import Box from "@mui/material/Box";
import { AppContext } from "../../context/AppContextProvider";
import { DateComparator } from "../../utils/DateComparator.js";
import { NumericComparator } from "../../utils/NumericComparator";
import HaqtGrid from "../../components/HaqtGrid/HaqtGrid";
import { getDashboardData } from '../../services/DashboardServices';
import { getSessionStorageItem } from "../../utils/sessionStorageUtils.js";
import {Link} from "react-router-dom";
import { combinedRecords } from "./CombinedRecords.js";
import { getCurrentDateTime } from "../../utils/CurrentDateTime.js";

const DashboardData = (props) => {
  const { setShowSpinner } = useContext(AppContext);
  const [ dashboardGridData, setDashboardGridData ] = useState({});
  const [ columnDefs, setColumnDefs ] = useState([]);
  const gridApiRef = useRef();

  const selectedSystemData = getSessionStorageItem("haqt-selected-system");
  const systemId = selectedSystemData?.system?.id;

  let tileName =  props.card.tileName || props.tile.tileName 

  const loadDashboardData = async () => {
    let parameterIds = props.tile 
      ? props.tile.parameters.map((parameter) => parameter.parameterId) 
      : [props.card.parameterId];

    try {
      setShowSpinner(true);
      const gridData = await dashboardDataApi(parameterIds, systemId); 
      console.log(gridData,"grid")
      setDashboardGridData(gridData);
      setShowSpinner(false);

      // setTimeout(() => {
      //   setDashboardGridData(testData["/getDashboardData"].response);
      //   setShowSpinner(false);
      // }, 1000);
    } catch (e) {
      setShowSpinner(false);
      console.log(e);
    }
  };

  useEffect(() => {
    loadDashboardData();
  }, []);

  useEffect(() => {
    if (dashboardGridData && dashboardGridData.columns) {
      const newColumnDefs = dashboardGridData.columns.map(column => {
        const colDef = {
          headerName: column.headerName,
          field: column.field,
          filter: true,
          sortable: true,
          minWidth: 150,
          comparator: column.dataType === "date" ? DateComparator : NumericComparator
        };
        return colDef;
      });

      setColumnDefs(newColumnDefs);
    }
  }, [dashboardGridData]);

  const dashboardDataApi = async (selectedParameterIds, systemId) => {
    try {
      const response = await getDashboardData(selectedParameterIds);
      return (response && response.data ? response.data : null);
    } catch (error) {
      console.log(error);
      return null;
    }
  }

  return (
    <Box className="dashboard-data-container">
      <Link style={{ color: '#005572', textDecoration: 'none', fontWeight: 'bold'}} to={"/admin/dataoverview"}>Go to System Data </Link>
      {dashboardGridData && dashboardGridData.data && !!dashboardGridData.data.length && <HaqtGrid
        rowData={combinedRecords(dashboardGridData.data)}
        columnDefs={columnDefs}
        gridApiRef={gridApiRef}
        isExport={true}
        sheetName={`Dashboard_${tileName}`}
        fileName={`Dashboard_${tileName}_${getCurrentDateTime()}`}
      />}
    </Box>
  );
};

export default DashboardData;
